<script>
export default {
  name: "verifyIcon",
};
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1654 10L17.132 7.675L17.4154 4.6L14.407 3.91667L12.832 1.25L9.9987 2.46667L7.16536 1.25L5.59036 3.90833L2.58203 4.58333L2.86536 7.66667L0.832031 10L2.86536 12.325L2.58203 15.4083L5.59036 16.0917L7.16536 18.75L9.9987 17.525L12.832 18.7417L14.407 16.0833L17.4154 15.4L17.132 12.325L19.1654 10ZM8.40703 13.9333L5.24036 10.7583L6.4737 9.525L8.40703 11.4667L13.282 6.575L14.5154 7.80833L8.40703 13.9333Z"
      fill="white"
    />
  </svg>
</template>

<style scoped></style>
